import { useEffect, useState } from 'react';
import { api, waLink } from '../lib/api';
import AraSec from '../ui/AraSec';

type Cari = { id: number | null; name: string; phone: string | null; kaynak: string };

/**
 * Yeni fason iş emri. Fasoncu kayıtlı değilse adıyla açılır — Mehmetcan
 * önce cari açmak zorunda kalmasın.
 */
const BIRIM_AD: Record<string, string> = { KUTU: 'kutu', M2: 'm²', ADET: 'adet', KG: 'kg', LT: 'lt', MTUL: 'metretül' };

export default function YeniFason({ kapat, eklendi }: { kapat: () => void; eklendi: () => void }) {
  const [cariler, setCariler] = useState<Cari[]>([]);
  const [contractorId, setContractorId] = useState('');
  const [contractorAd, setContractorAd] = useState('');
  const [contractorTel, setContractorTel] = useState('');
  const [title, setTitle] = useState('');
  /* Fasona verilen ürünler: ürün + miktar. */
  type Urun = { id: number; code: string; name: string; unit: string };
  const [urunler, setUrunler] = useState<Urun[]>([]);
  const [kalemler, setKalemler] = useState<{ productId: number; code: string; name: string; unit: string; qty: string }[]>([]);
  const [secUrun, setSecUrun] = useState('');
  const [secAdet, setSecAdet] = useState('1');
  const [stoktanDus, setStoktanDus] = useState(true);
  useEffect(() => {
    api<{ satirlar: Urun[] }>('/api/urunler?durum=hepsi&limit=2000&sirala=kod').then((r) => setUrunler(r.satirlar)).catch(() => undefined);
  }, []);
  function kalemEkle() {
    const u = urunler.find((x) => String(x.id) === secUrun);
    if (!u) { setHata('Önce listeden ürün seçin'); return; }
    if (!(Number(secAdet) > 0)) { setHata('Miktar sıfırdan büyük olmalı'); return; }
    setHata(null);
    setKalemler((k) => [...k.filter((x) => x.productId !== u.id), { productId: u.id, code: u.code, name: u.name, unit: u.unit, qty: secAdet }]);
    setSecUrun(''); setSecAdet('1');
  }
  const [description, setDescription] = useState('');
  const [costTl, setCostTl] = useState('');
  const [gecerlilikGun, setGecerlilikGun] = useState('30');
  const [hata, setHata] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);
  const [sonuc, setSonuc] = useState<{ no: string; portalUrl: string; contractor: { name: string; phone: string | null } } | null>(null);

  const [adayAcik, setAdayAcik] = useState(false);
  useEffect(() => {
    let iptal = false;
    const t = setTimeout(() => {
      api<{ adaylar: Cari[] }>(`/api/cariler/fason-ara?ara=${encodeURIComponent(contractorAd.trim())}`)
        .then((r) => { if (!iptal) setCariler(r.adaylar); })
        .catch(() => { if (!iptal) setCariler([]); });
    }, 200);
    return () => { iptal = true; clearTimeout(t); };
  }, [contractorAd]);

  async function gonder(e: React.FormEvent) {
    e.preventDefault();
    setHata(null); setBekliyor(true);
    try {
      const r = await api<{ no: string; portalUrl: string; contractor: { name: string; phone: string | null } }>(
        '/api/fason',
        {
          method: 'POST',
          body: JSON.stringify({
            contractorId: contractorId ? Number(contractorId) : undefined,
            contractorAd: contractorId ? undefined : contractorAd.trim(),
            contractorTel: contractorId ? undefined : contractorTel.trim(),
            title: title.trim() || undefined,
            kalemler: kalemler.map((k) => ({ productId: k.productId, qty: Number(k.qty) })),
            description: description || undefined,
            costTl: costTl ? Number(costTl) : undefined,
            gecerlilikGun: Number(gecerlilikGun),
            stoktanDus,
          }),
        }
      );
      setSonuc(r);
    } catch (err) {
      setHata(err instanceof Error ? err.message : 'İş emri açılamadı');
    } finally {
      setBekliyor(false);
    }
  }

  const whatsapp = sonuc && waLink(sonuc.contractor.phone,
        `Merhaba, ${sonuc.no} numaralı iş emri:\n${title}\n\nDetay ve dosyalar:\n${sonuc.portalUrl}\n\nArt Mozaik & Seramik`);

  return (
    <div className="ccd-drawer-arka" onClick={kapat} role="presentation">
      <aside className="ccd-drawer" onClick={(e) => e.stopPropagation()}
             role="dialog" aria-modal="true" aria-label="Yeni iş emri">
        {sonuc ? (
          <div className="ccd-stack">
            <div className="ccd-row-between">
              <div>
                <div className="ccd-eyebrow ccd-mono">{sonuc.no}</div>
                <h2 className="ccd-heading">İş emri açıldı</h2>
              </div>
              <button className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={eklendi}>Kapat</button>
            </div>
            <div className="ccd-banner">
              <span className="ccd-banner-icon" aria-hidden="true">✓</span>
              <div>
                <div style={{ fontWeight: 600 }}>{sonuc.contractor.name} için hazır.</div>
                <div className="ccd-meta">
                  Bağlantıyı gönderin; fasoncu şifresiz açar, dosyaları indirir, adımları tıklar.
                </div>
              </div>
            </div>
            <input className="ccd-input ccd-mono" readOnly value={sonuc.portalUrl}
                   onFocus={(e) => e.currentTarget.select()} aria-label="Fasoncu bağlantısı" />
            <div className="ccd-row" style={{ flexWrap: 'wrap' }}>
              <button className="ccd-btn ccd-btn-sm"
                      onClick={() => void navigator.clipboard.writeText(sonuc.portalUrl)}>
                Bağlantıyı kopyala
              </button>
              {whatsapp && (
                <a className="ccd-btn ccd-btn-accent ccd-btn-sm" href={whatsapp} target="_blank" rel="noreferrer">
                  WhatsApp ile gönder
                </a>
              )}
              <button className="ccd-btn ccd-btn-primary ccd-btn-sm" onClick={eklendi}>
                Listeye dön (dosya eklemek için aç)
              </button>
            </div>
          </div>
        ) : (
          <form className="ccd-stack" onSubmit={gonder}>
            <div className="ccd-row-between">
              <div>
                <div className="ccd-eyebrow">Fason</div>
                <h2 className="ccd-heading">Yeni iş emri</h2>
              </div>
              <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={kapat}>
                Kapat
              </button>
            </div>

            {(
              <div className="ccd-form-grid">
                <div className="ccd-field" style={{ position: 'relative' }}>
                  <label className="ccd-field-label" htmlFor="fad">
                    Fasoncu<span className="ccd-required"> *</span>
                  </label>
                  <input id="fad" className="ccd-input" required autoComplete="off"
                         placeholder="Adını yazın — kayıtlıysa listeden seçin"
                         value={contractorAd}
                         onFocus={() => setAdayAcik(true)}
                         onBlur={() => setTimeout(() => setAdayAcik(false), 150)}
                         onChange={(e) => { setContractorAd(e.target.value); setContractorId(''); setAdayAcik(true); }} />
                  {adayAcik && cariler.length > 0 && (
                    <div className="ccd-oneri" role="listbox">
                      {cariler.map((c, n) => (
                        <button key={n} type="button" role="option" aria-selected={false} className="ccd-oneri-satir"
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  setContractorAd(c.name); setContractorId(c.id ? String(c.id) : '');
                                  setContractorTel(c.phone ?? ''); setAdayAcik(false);
                                }}>
                          <span className="ccd-oneri-ad">{c.name}{c.phone ? <span className="ccd-muted"> · {c.phone}</span> : null}</span>
                          <span className="ccd-muted">{c.kaynak}</span>
                        </button>
                      ))}
                    </div>
                  )}
                  <div className="ccd-field-hint">
                    {contractorId ? 'Kayıtlı cari seçildi.' : contractorAd.trim().length >= 2 ? 'Listede yoksa bu adla yeni fasoncu olarak kaydedilir.' : 'Fasoncular, Paraşüt tedarikçileri ve cariler aranır.'}
                  </div>
                </div>
                <div className="ccd-field">
                  <label className="ccd-field-label" htmlFor="ftel">Telefon</label>
                  <input id="ftel" className="ccd-input" placeholder="+90 5xx xxx xx xx"
                         value={contractorTel} onChange={(e) => setContractorTel(e.target.value)} />
                  <div className="ccd-field-hint">Girilirse WhatsApp düğmesi çıkar.</div>
                </div>
              </div>
            )}

            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="furun">Fasona verilen ürünler</label>
              <div className="ccd-row" style={{ gap: 8, alignItems: 'stretch', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 260px' }}>
                  <AraSec id="furun" deger={secUrun} degis={setSecUrun} yerTutucu="Ürün ara: kod ya da ad…"
                          secenekler={urunler.map((u) => ({ id: u.id, ad: `${u.code} — ${u.name}` }))} />
                </div>
                <input className="ccd-input" type="number" inputMode="decimal" step="any" min={0} style={{ width: 90 }} aria-label="Miktar"
                       value={secAdet} onChange={(e) => setSecAdet(e.target.value)}
                       onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); kalemEkle(); } }} />
                <button type="button" className="ccd-btn" onClick={kalemEkle}>Ekle</button>
              </div>
              {kalemler.length === 0 ? (
                <div className="ccd-field-hint">Hangi üründen kaç adet verdiğinizi ekleyin; fasoncu bağlantıda görür. İş yalnız hizmetse boş bırakın.</div>
              ) : (
                <div className="ccd-stack-sm" style={{ marginTop: 8 }}>
                  {kalemler.map((k) => (
                    <div key={k.productId} className="ccd-row-between" style={{ gap: 8 }}>
                      <span style={{ minWidth: 0 }}><b className="ccd-mono">{k.code}</b> {k.name}</span>
                      <span className="ccd-row" style={{ gap: 6, flex: '0 0 auto' }}>
                        <input className="ccd-input" type="number" inputMode="decimal" step="any" min={0} style={{ width: 80, textAlign: 'right' }} aria-label={`${k.code} miktar`}
                               value={k.qty} onChange={(e) => setKalemler((x) => x.map((y) => (y.productId === k.productId ? { ...y, qty: e.target.value } : y)))} />
                        <span className="ccd-meta">{BIRIM_AD[k.unit] ?? k.unit}</span>
                        <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={() => setKalemler((x) => x.filter((y) => y.productId !== k.productId))}>Sil</button>
                      </span>
                    </div>
                  ))}
                  <label className="ccd-meta" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <input type="checkbox" checked={stoktanDus} onChange={(e) => setStoktanDus(e.target.checked)} />
                    Verilen ürünleri stoktan düş (iş bitince "Teslim al" ile geri girer)
                  </label>
                </div>
              )}
            </div>

            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="bas">
                İş başlığı
              </label>
              <input id="bas" className="ccd-input" required minLength={3}
                     placeholder="Taksim 360 — zemin göbek waterjet kesimi"
                     value={title} onChange={(e) => setTitle(e.target.value)} />
            </div>

            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="ack">Açıklama</label>
              <textarea id="ack" className="ccd-textarea" rows={4}
                        placeholder="1,8 m çap göbek; antrasit + krem. DWG ekte."
                        value={description} onChange={(e) => setDescription(e.target.value)} />
            </div>

            <div className="ccd-form-grid">
              <div className="ccd-field">
                <label className="ccd-field-label" htmlFor="mal">Maliyet (TL)</label>
                <input id="mal" className="ccd-input" type="number" inputMode="decimal" step="any"
                       value={costTl} onChange={(e) => setCostTl(e.target.value)} />
                <div className="ccd-field-hint">Fasoncu görmez.</div>
              </div>
              <div className="ccd-field">
                <label className="ccd-field-label" htmlFor="gec">Bağlantı geçerliliği (gün)</label>
                <input id="gec" className="ccd-input" type="number" inputMode="numeric" min={1} max={365}
                       value={gecerlilikGun} onChange={(e) => setGecerlilikGun(e.target.value)} />
              </div>
            </div>

            {hata && (
              <div className="ccd-banner ccd-banner-danger">
                <span className="ccd-banner-icon" aria-hidden="true">!</span><span>{hata}</span>
              </div>
            )}

            <button className="ccd-btn ccd-btn-primary" disabled={bekliyor}>
              {bekliyor ? 'Açılıyor…' : 'İş emrini aç ve bağlantı üret'}
            </button>
          </form>
        )}
      </aside>
    </div>
  );
}
